import React from 'react'
import { withAsync } from '@/components/Async'
import type { RouteConfig } from 'react-router-config'
import { Redirect } from 'react-router'
import Blank from '@/layouts/Blank'

const routes: RouteConfig[] = [
  {
    path: '/home',
    component: Blank,
    routes: [
      {
        name: 'downloadCenter',
        path: '/downloadCenter',
        component: withAsync(() => import(/* webpackChunkName: "DownloadCenter" */ '@/containers/Home/DownloadCenter')),
        exact: true,
      },
      {
        name: 'noticeCenter',
        path: '/noticeCenter',
        component: withAsync(() => import(/* webpackChunkName: "noticeCenter" */ '@/containers/Home/NoticeCenter')),
        exact: true,
      },
      {
        path: '/',
        component() {
          return <Redirect to="/home/downloadCenter" />
        },
        exact: true,
      },
    ],
  },
]

export default routes
